export default __webpack_public_path__ + "117e8d5c9ff1e99f38bae44bd3d8972c.png";